import { type Worker } from "@src/appV2/Worker/api/types";

import { type PrerequisiteAction, type WorkerRequirement } from "../api/types";

interface GetIncompleteRequirementPrerequisiteActionsProps {
  worker: Worker;
  workerRequirement: WorkerRequirement;
}

export const PRE_REQUIREMENT_ACTION_KEYS = {
  SSN_REQUIRED: "ssn-required",
} as const;

export function getIncompleteRequirementPrerequisiteActions(
  props: GetIncompleteRequirementPrerequisiteActionsProps
): PrerequisiteAction[] {
  const { worker, workerRequirement } = props;

  return (workerRequirement.prerequisiteActions ?? []).filter((action) => {
    if (action.actionKey === PRE_REQUIREMENT_ACTION_KEYS.SSN_REQUIRED) {
      return !worker.socialSecurityNumber;
    }

    return false;
  });
}
